/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2021-2023 OKTET Labs Ltd. */
export const enum HistoryAggregationColumns {
	ParametersHash = 'parameters-hash',
	ResultsLog = 'results-log'
}
